import { yupResolver } from "@hookform/resolvers/yup";
import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import TextField from "component/textField/TextField";
import ValidationMessage from "component/validationMessage/ValidationMessage";
import React from "react";
import { useForm } from "react-hook-form";
import ReactSignatureCanvas from "react-signature-canvas";
import { signatureFieldSchema } from "schemas/mortgageApplication/MortgageApplicationSchema";
import styles from "./SignatureField.module.css";

function SignatureField({
  name,
  setValue,
  sigCanvas,
  setImageURL,
  handleCloseField,
}) {
  const {
    register,
    watch,
    setValue: setSigName,
    formState: { errors: fullNameErrors },
    handleSubmit,
  } = useForm({
    resolver: yupResolver(signatureFieldSchema),
  });
  const create = () => {
    const URL = sigCanvas.current.getTrimmedCanvas().toDataURL("image/png");
    setImageURL(URL);
    handleCloseField();
  };

  const onSubmit = (data) => {
    setValue(name, data.fullname);
    create();
  };

  return (
    <div className={styles.signature_field}>
      <div className={styles.field}>
        <TextField
          textValidation
          setValue={setSigName}
          watch={watch}
          required={true}
          name="fullname"
          register={register}
          errors={fullNameErrors}
          label="Full Name"
          type="text"
          placeholder="Insert Full Name"
        />
      </div>
      <div className={styles.field}>
        <div className={styles.heading}>
          <Typography>Signature (Draw signature)</Typography>
          <span style={{ color: "red" }}>*</span>
        </div>
        <div className={styles.sign_field}>
          <ReactSignatureCanvas
            ref={sigCanvas}
            penColor="black"
            canvasProps={{
              width: 300,
              height: 200,

              className: "sigCanvas",
            }}
          />

          <div className={styles.clear_btn}>
            <AppButton
              height="40px"
              handleAction={() => {
                sigCanvas.current.clear();
                setImageURL(null);
              }}
              textColor="#0a2240"
              btnBg="#ffc107"
              btnText="Clear"
              width="30%"
            />
          </div>
        </div>

        {/* {errors[signatureName] && (
          <ValidationMessage message={errors[signatureName].message} />
        )} */}
      </div>

      <div className={styles.sign_field_btns}>
        <AppButton
          height="40px"
          handleAction={() => {
            handleCloseField();
          }}
          textColor="#fff"
          btnBg="#CE0000"
          btnText="Cancel"
          width="30%"
        />
        <AppButton
          height="40px"
          handleAction={handleSubmit(onSubmit)}
          textColor="#FFFFFF"
          btnBg="#0072CE"
          btnText="Done"
          width="30%"
        />
      </div>
    </div>
  );
}

export default SignatureField;